import React from 'react';
import { getTumbnail, RATIO_16x9  } from '../../../util/imageUtils';

const Thumbnail = (props = {}) => {
	const className = props.className;

	return (<React.Fragment>
		<div className={className ? className : 'img-wrp'}>
			<img loading='lazy' src={getTumbnail(props.thumbnails,  props.ratio || RATIO_16x9, props.maxWidth)} alt={props.title} title={props.title}></img>
			{/* <img data-src={getTumbnail(props.thumbnails,  props.ratio || RATIO_16x9, props.maxWidth)} alt={props.title} title={props.title}></img> */}
		</div>
	</React.Fragment>);
};

export default Thumbnail;